import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import Auth from "./modules/AuthModule"
import Common from "./modules/Common.store";

Vue.use(Vuex);

const modules = {
    Auth: Auth,
    Common: Common,
};

export default new Vuex.Store({
    modules,
    plugins: [createPersistedState()]
});
